import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  HostListener,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { forwardRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-page-size-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PageSizeSelectorComponent),
      multi: true,
    },
  ],
  templateUrl: './page-size-selector.component.html',
  styleUrl: './page-size-selector.component.scss',
})
export class PageSizeSelectorComponent implements ControlValueAccessor, OnInit {
  @Input() sizes: number[] = [10, 15, 25, 50, 100];
  @Input() selectedSize: number = 10;
  @Output() sizeChange = new EventEmitter<number>();

  isOpen = false;
  private onChange: (value: number) => void = () => {};
  private onTouched: () => void = () => {};

  get reversedSizes(): number[] {
    return [...this.sizes].reverse();
  }

  writeValue(value: number): void {
    if (value !== undefined && value !== null) {
      this.selectedSize = value;
    }
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    // Ensure selectedSize is in the sizes array, if not add it
    if (!this.sizes.includes(this.selectedSize)) {
      this.sizes = [...this.sizes, this.selectedSize].sort((a, b) => a - b);
    }
  }

  selectSize(size: number): void {
    this.selectedSize = size;
    this.isOpen = false;
    this.onChange(size);
    this.onTouched();
    this.sizeChange.emit(size);
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.page-size-dropdown')) {
      this.isOpen = false;
    }
  }
}
